import withUser from '../../Login/withUser'
import LoginLink from './LoginLink'
import ProfileDropdown from '../../Profile/ProfileDropdown'

export default withUser({
  FallbackComponent: LoginLink
})(ProfileDropdown)
